export default __webpack_public_path__ + "img/c309c8cd63a14c778bb1179e9fbe9df8.svg";